import { useTranslation } from 'react-i18next'
import { ContentSection } from '../components/content-section'
import { AccountForm } from './account-form'

export function SettingsAccount() {
  const { t } = useTranslation('common')

  return (
    <ContentSection
      title={t('settingsAccount.title')}
      desc={t('settingsAccount.description')}
    >
      <AccountForm />
    </ContentSection>
  )
}
